export const DateFields = [
  'password_changed',
  'vrm_start_date',
  'hireDate',
  'drive_work_datedone',
  'system_created_date',
  'system_modified_date',
  'vrm_end_date',
  'mvr_dob',
];

export const NameFields = ['managersName', 'fullName'];

export const ImportJobStatus = {
  INITIATED: { text: 'Initiated', step: 'File Upload', class: 'yellow' },
  UPLOADED: { text: 'Uploaded', step: 'Data Validation', class: 'yellow' },
  COMPLETED_WITH_VALIDATION_ERROR: { text: 'Validation Error', step: 'Data Validation', class: 'red' },
  VALIDATED: { text: 'Pending Approval', step: 'Approval Review', class: 'yellow' },
  COMPLETED_AS_REJECTED: { text: 'Rejected', step: 'Approval Review', class: 'red' },
  COMPLETED_AS_CANCELLED: { text: 'Cancelled', step: 'Approval Review', class: 'red' },
  COMPLETED_AS_NO_CHANGE: { text: 'Unchanged', step: 'Completed', class: 'blue' },
  APPROVED: { text: 'Approved', step: 'Final Processing', class: 'yellow' },
  PROVISION_ENQUEUING: { text: 'Processing', step: 'Final Processing', class: 'yellow' },
  PROVISION_IN_PROGRESS: { text: 'Processing', step: 'Final Processing', class: 'yellow' },
  COMPLETED_SUCCESSFULLY: { text: 'Completed', step: 'Completed', class: 'green' },
  COMPLETED_WITH_PROVISION_ERROR: { text: 'Completed with Error', step: 'Completed', class: 'red' },
};
